import { createSlice,current } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}

const showConfrenceDataSlice = createSlice({
    name:'showConfrenceData',
    initialState,
    reducers:{
        addShowConfrenceData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        },
        updateConfrenceData:(_state,payload)=>{
            const { localVideoMuted } = payload.payload
            return {
                "id" : uuidv4(),
                "data": {...current(_state).data,localVideoMuted:localVideoMuted}
            }
        },
        resetConferenceData: ()=>{
            return {
             "id" : uuidv4(),
             "data": {}
            }
     }
    }
});

export default showConfrenceDataSlice.reducer
export const addShowConfrenceData = showConfrenceDataSlice.actions.addShowConfrenceData
export const updateConfrenceData = showConfrenceDataSlice.actions.updateConfrenceData
export const resetConferenceData = showConfrenceDataSlice.actions.resetConferenceData